module.exports = __webpack_public_path__ + "static/media/평화지도_스케치(컬러링).76ebf18b.jpg";